var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Badge',{attrs:{"variant":_vm.variant,"text":_vm.$t('simulations.' + _vm.status).toString(),"loading":_vm.loading}})
}
var staticRenderFns = []

export { render, staticRenderFns }